angular.module('shared.directives.fixedTableHeaders', [])
    .directive('fixedTableHeaders', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var ticking = false;
                    var headerEl = null;

                    /**
                     * Recompute and apply the sticky-header offset. Runs at most
                     * once per animation frame (see onScroll) so a burst of scroll
                     * events collapses into a single DOM read/write pass instead of
                     * forcing a synchronous reflow on every scroll event.
                     */
                    function update() {
                        ticking = false;

                        // Cache the thead lookup; it does not change for this table.
                        headerEl = headerEl || element[0].querySelector('thead');
                        if (!headerEl) {
                            return;
                        }

                        // --- reads (batched together to avoid layout thrashing) ---
                        var rect = element[0].getBoundingClientRect();

                        // Calculate heights of combined 'sticky' elements as these
                        // need to sit above the header
                        var stickToYPosition = 0;
                        var stickyEls = document.getElementsByClassName('sticky');
                        for (var i = 0; i < stickyEls.length; i++) {
                            stickToYPosition += stickyEls[i].offsetHeight;
                        }

                        var scrollTop = (rect.top < 0) ? Math.abs(rect.top) + stickToYPosition : 0;

                        // --- writes (after all reads) ---
                        headerEl.style.transform = 'translateY(' + scrollTop + 'px)';
                        if (scrollTop > 0) {
                            headerEl.classList.add("static");
                        } else {
                            headerEl.classList.remove("static");
                        }
                    }

                    /**
                     * scroll handle
                     * @param {event} e -- scroll event
                     */
                    function scrollHandle(e) {
                        // Coalesce scroll bursts into one update per frame.
                        if (!ticking) {
                            ticking = true;
                            requestAnimationFrame(update);
                        }
                    }

                    var start = $timeout(function () {
                        // passive: this handler never calls preventDefault, so let the
                        // browser scroll without waiting on it.
                        window.addEventListener('scroll', scrollHandle, { passive: true });
                    }, 0);

                    // Remove the global listener when the directive is destroyed,
                    // otherwise every table render leaks another scroll handler that
                    // keeps thrashing layout for the life of the page.
                    scope.$on('$destroy', function () {
                        $timeout.cancel(start);
                        window.removeEventListener('scroll', scrollHandle, { passive: true });
                    });
                }
            };
        }]);